<ziro-radio [fieldId]="'scheduleType'"></ziro-radio>

<ziro-time-ranges
  [fieldId]="'slots'"
  [isFormSubmitted]="isFormSubmitted"
  [canAddRanges]="true"
  [inlineLabel]="false"
  [dataAutomation]="'weekly-schedule-day-modal-time-ranges'"
></ziro-time-ranges>

<ng-template #errorTemplate>
  @if (
    isFormSubmitted &&
    (validationState === validationStates.INVALID || childFormValidationState === validationStates.INVALID)
  ) {
    <span>
      {{ 'tkey;validators.global.required.missing.error' | translate }}
    </span>
  }
</ng-template>
